import { useAuthStore } from '../stores/authStore'
import { loadInterfaceTable, resolveLocale } from './app'
import { detectLocale, guessLocale } from './landing'
import { loadLanguageRegistry } from './registry'

// A bound on how long the first paint waits for a table. Past it the app
// renders in English and switches when the table arrives; only a very slow
// network reaches it.
const FIRST_PAINT_WAIT_MS = 3000

/**
 * Load what the first screen needs before it renders, so no one sees a frame
 * of the wrong language (ADR-111, per-locale tables):
 *  - signed in: the table of the account's interface_language;
 *  - signed out: the registry (release decides what the landing page may
 *    offer) and the table the landing page will choose. That table is
 *    requested at once, on a guess, in parallel with the registry.
 * Never rejects.
 */
export async function prepareFirstPaint(): Promise<void> {
  const registry = loadLanguageRegistry().catch(() => null)
  const user = useAuthStore.getState().user
  const ready = user
    ? loadInterfaceTable(resolveLocale(user.interface_language)).catch(() => undefined)
    : Promise.all([
        loadInterfaceTable(guessLocale()).catch(() => undefined),
        registry.then((r) => loadInterfaceTable(detectLocale(r)).catch(() => undefined)),
      ])
  await Promise.race([ready, new Promise((resolve) => setTimeout(resolve, FIRST_PAINT_WAIT_MS))])
}
